import createReactComponent from '../createReactComponent';
var Rss = createReactComponent('Rss', [['path', {
  d: 'M4 11a9 9 0 019 9',
  key: '104m8c'
}], ['path', {
  d: 'M4 4a16 16 0 0116 16',
  key: '16he5u'
}], ['circle', {
  cx: '5',
  cy: '19',
  r: '1',
  key: 'bfqh0e'
}]]);
export default Rss;